// DEV
// import awsconfig_dev from "./aws-exports_dev.js";
// const awsconfig = awsconfig_dev;

// PROD
import awsconfig_prod from "./aws-exports_v0p1p0.js";
const awsconfig = awsconfig_prod;

export default awsconfig;